import { FormSection } from '@ksyos/design-system';
import type { OsasFollowUpConsultCustomControlData } from '@common/validation/customControls/osas/osasFollowUpConsultSchema';
import {
    DateInputFormGroup,
    TextAreaFormGroup,
} from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';
import { useOsasAllTreatments } from '@frontend/utils/hooks/useOsasAllTreatments';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { ProcessActivityAssetsDropzone } from '../../processActivityAssets/ProcessActivityAssetsDropzone';
import { SleepStudyFindings } from '../osasConsult/components/SleepStudyFindingsFormGroup';
import { CurrentPolicyFormSection } from './components/CurrentPolicyFormSection';
import { PolicyFormSection } from './components/PolicyFormSection';

export function OsasFollowUpConsultEdit() {
    const { errors, data, onChange, processActivityId } =
        useProcessActivityEditContext<OsasFollowUpConsultCustomControlData>();
    const { onChangeTreatment, onChangeTrialPeriod, inProgressTreatments, hasInProgressTreatments } =
        useOsasAllTreatments({ onChange });

    return (
        <>
            <FormSection>
                <DateInputFormGroup
                    error={getDateError()}
                    fieldKey="consultDate"
                    isRequired={true}
                    label="Datum contact"
                />
                <TextAreaFormGroup
                    fieldKey="anamnesis"
                    isRequired={true}
                    label="Anamnese"
                />
            </FormSection>
            <FormSection title="Vervolgonderzoek">
                <SleepStudyFindings
                    data={data}
                    errors={errors}
                    onChange={onChange}
                    processActivityId={processActivityId}
                />
                <TextAreaFormGroup
                    fieldKey="notes"
                    label="Notitie"
                />
            </FormSection>
            <FormSection title="Conclusie">
                <TextAreaFormGroup
                    fieldKey="conclusie"
                    isRequired={true}
                    label="Conclusie"
                    placeholder="Omschrijf je werkdiagnose en mogelijke differentiaaldiagnoses..."
                />
                <ProcessActivityAssetsDropzone
                    label="Bestand(en)"
                    maxFiles={20}
                />
            </FormSection>

            <CurrentPolicyFormSection
                data={data}
                errors={errors}
                hasInProgressTreatments={hasInProgressTreatments}
                inProgressTreatments={inProgressTreatments}
                onChange={onChange}
                onChangeTrialPeriod={onChangeTrialPeriod}
            />

            <PolicyFormSection
                data={data}
                errors={errors}
                onChange={onChange}
                onChangeTreatment={onChangeTreatment}
            />
        </>
    );

    function getDateError() {
        if (errors.has('consultDate')) {
            if (!data.consultDate) {
                return 'any_required';
            }

            return errors.get('consultDate');
        }
    }
}
